<script>
import Loader from './Loader.svelte';

export let title;
export let loading = false;
</script>

<button class="btn btn-primary form-button" type="submit">
    {#if loading}
        <Loader class="mx-auto text-xl"></Loader>
    {:else}
        {title}
    {/if}
</button>
